import {Component, ViewChild, OnDestroy} from '@angular/core';
import {Content, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {Beneficiaire} from '../../shared/models/beneficiaire/beneficiaire.model';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/do';
import {BeneficiairesService} from '../../shared/services/beneficiaires.service';
import {Search} from '../../shared/models/search/search.model';
import {CorePage} from '../../shared/interfaces/corePage.interface';
import {OauthService} from '../../shared/services/oauth.service';
import {AuthService} from '../../shared/services/auth.service';
import {LoadingService} from '../../shared/services/loading.service';
import { UserStorageService } from '../../shared';
import {UserService} from "../../shared/services/user.service";

/**
 * Generated class for the BeneficiaireListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-beneficiaire-list',
  templateUrl: 'beneficiaire-list.html'
})
export class BeneficiaireListPage implements CorePage, OnDestroy {
  @ViewChild(Content) content: Content;
  public beneficiaires: Array<Beneficiaire>;
  public searchQuery$ = new Subject<Search>();
  public isLoading = new Subject();
  public termSearch: string = '';
  public limit: number = 15;
  public totalPages = false;
  public noResult = false;
  public isComponentReady: boolean = false;
  public offset: number = null;
  readonly authService: AuthService;
  readonly allowedMode = ['elu'];
  public pageTitle: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private beneficiairesService: BeneficiairesService,
    public loadingCtrl: LoadingController,
    public oauthService: OauthService,
    public loadingService: LoadingService,
    private storage: UserStorageService,
    private userService: UserService,
  ) {
    this.authService = new AuthService(
      this.allowedMode,
      this.navCtrl,
      this.oauthService,
      this.storage
    );
  }

  ionViewCanEnter() {
    return this.authService.ionViewCanEnter();
  }

  ionViewWillEnter() {
    this.authService.ionViewCanEnter();

    this.offset = this.offset === this.limit ? 0 : this.offset;
    this.initializeBeneficiaires();

    // Sauvegarde des stats de connexion
    this.userService.saveStatUtilisateur().subscribe(resp => {}, error => console.log(error));
  }

  ngOnDestroy() {
    this.isLoading.unsubscribe();
    this.searchQuery$.unsubscribe();
  }

  initializeBeneficiaires(search: string = null) {
    this.beneficiairesService
      .getAll(this.searchQuery$, this.limit, this.offset)
      .subscribe(response => {
        const data = response.data;
        const action = response.action;

        if (action === 'scroll' && data.data.length > 0) {
          // if action scroll and there are data
          for (let i = 0; i < data.data.length; i++) {
            this.beneficiaires.push(data.data[i]); // add new benef to list
          }
          this.totalPages = data.data.length < this.limit;
          this.offset += this.limit; // update offset
          this.isLoading.next(); // subject for disable loader scroll

        } else if (action === 'scroll' && data.data.length === 0) {
          // if action scroll and there isn't data
          this.totalPages = true; // disable infinite scroll
          this.isLoading.next(); // subject for disable loader scroll

        } else {
          // if action init or new search
          this.beneficiaires = data.data; // init list
          this.offset = this.limit; // init offset

          // Enable / disable infinite scroll
          this.totalPages = data.data.length < this.limit;
          // Show / hide no result text
          this.noResult = 0 === data.total;
        }

        this.content.resize();
        this.loadingService.end();
        this.isComponentReady = true;
      });

    this.searchQuery$.next(
      new Search({
        term: this.termSearch,
        action: 'init',
        limit: this.limit,
        offset: this.offset
      } as Search)
    ); // init value
  }

  doInfinite(infiniteScroll) {
    // Infinite scroll
    this.searchQuery$.next(
      new Search({
        term: this.termSearch,
        action: 'scroll',
        limit: this.limit,
        offset: this.offset
      } as Search)
    ); // load data for other pages

    this.isLoading.first().subscribe(x => {
      console.log('Async operation has ended!');
      infiniteScroll.complete();
    }); // create subscriber for disable loader scroll when data is loaded
  }

  onClick(id) {
    this.navCtrl.push('BeneficiairePage', {
      beneficiaire: id,
      tab: 'benef-card'
    }); // link to benef page
  }

  onAddBeneficiaire() {
    this.navCtrl.push('BeneficiaireFormPage'); // link to add benef page
  }

  onSearch($event) {
    const val = $event.target.value;

    if (
      (val && val.length >= 3) ||
      !val ||
      (val && val.length === 0 && this.termSearch.trim() !== '')
    ) {
      // search if val is > 3 letters
      this.noResult = false;
      this.termSearch = val;
      this.offset = null; // init offset
      this.searchQuery$.next(
        new Search({
          term: this.termSearch,
          action: 'search',
          limit: this.limit,
          offset: this.offset
        } as Search)
      ); // new search and init limit and offset
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/beneficiaire-list/beneficiaire-list.ts